import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ToastrService } from "ngx-toastr";
import { Store } from "@ngrx/store";
import { IAppStore } from "../iappstore";
import { Observable } from "rxjs";
import { map, catchError, tap, switchMap } from "rxjs/operators";
import { BaseService } from "./base.service";

@Injectable()
export class DataExportService extends BaseService {
   /**
    * Constructor for service
    * @param http angular http module
    * @param toastr toastr manager
    * @param authService Authorization Service
    */
    constructor(httpClient: HttpClient, toastr: ToastrService, store: Store<IAppStore>) {
        super(httpClient, toastr, store);
    }

    getImportTemplate(): Observable<Response> {
        return super
            .getWithContentType("api/dataexport/template", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
            .pipe(map((r: any) => { return r; }));
    }

    getCountryData(): Observable<Response> {
        return super
            .getWithContentType("api/dataexport/bulkexport", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
            .pipe(map((r: any) => { return r; }));
    }
    getCountryLiveandDraftData(): Observable<Response> {
        return super
            .getWithContentType("api/dataexport/liveanddraftbulkexport", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
            .pipe(map((r: any) => { return r; }));
    }

    getCountryStatusExport(): Observable<Response> {
        return super
            .getWithContentType("api/country/getwithstatusexport", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
            .pipe(map((r: any) => { return r; }));
    }
    getUsersImportTemplate(): Observable<Response> {
        return super
            .getWithContentType("api/userdataexport/template", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
            .pipe(map((r: any) => { return r; }));
    }

}




